import React, { useEffect, useState, useCallback } from "react";
import { trackFeatureAction } from "../../../analytics/googleAnalytics";
import moment from 'moment';
import { useDispatch, useSelector } from "react-redux";
import {
  fetchRegistrationDetails,
  fetchFilteredRegistrationDetails,
} from "../../../redux/slice/registrationDetails";
import { HashLoader } from "react-spinners";
import { Card, Button, Input, Select, Space, Table, Alert, Empty,DatePicker } from "antd";
import { StyledTable, StyledButton } from "../components/styleComp";
import { useAuth } from "../../../context/AuthContext";
import jwt_decode from "jwt-decode";
import {downloadRegistrationReport} from "../../../redux/slice/registrationDetails"

const { Option } = Select;

const RegistrationDetails = (props) => {
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null); 
    const [buttonLoading, setButtonLoading] = useState(false);
  const { authState } = useAuth();
  const dispatch = useDispatch();

  const [state, setState] = useState({
    pages: { registrationDetails: { page: 1, pageSize: 7 } },
    filters: { registrationDetails: {} },
    searchInputs: { registrationDetails: "" },
    selectedColumns: { registrationDetails: "" },
    hasSearched: { registrationDetails: false },
  });

  const [triggerFilter, setTriggerFilter] = useState(null);

  const jwtBearer = authState?.token;
  const tokenDecoded = jwtBearer ? jwt_decode(jwtBearer) : null;
  const jwtPayload = tokenDecoded
    ? {
        group: props?.userDetails?.group_id,
        user: tokenDecoded?.user_id,
        role: props?.userDetails?.role,
        expiry: tokenDecoded?.exp,
      }
    : {};

  // Fetch data when JWT bearer is available
  useEffect(() => {
    if (jwtBearer) {
      const { page, pageSize } = state?.pages?.registrationDetails;
      dispatch(
        fetchRegistrationDetails({
          jwtBearer,
          page,
          filters: state?.filters?.registrationDetails,
          pageSize,
        })
      );
    }
  }, [jwtBearer, state?.pages?.registrationDetails, state?.filters?.registrationDetails, dispatch]);

  const {
    data: registrationDetailsData = [],
    filteredData: filteredRegistrationDetailsData = [],
    totalCount: totalRegistrationDetailsCount,
    loading: isLoadingRegistrationDetails,
    filteredLoading: isLoadingFilteredRegistrationDetails,
    error: errorRegistrationDetails,
  } = useSelector((state) => state?.registrationDetails || {});

  console.log("Registration Details Data:", registrationDetailsData);
  console.log("Filtered Registration Details Data:", filteredRegistrationDetailsData);
  console.log("Total Count:", totalRegistrationDetailsCount);


  const defineColumns = useCallback((data) => {
    if (!data || data?.length === 0) return [];
    const keys = Object.keys(data[0]);
    return keys.map((key) => ({
      title: <strong style={{ fontSize: "18px" }}>{key.replace(/_/g, " ").toUpperCase()}</strong>,
      dataIndex: key,
      key: key,
      render: (text) => <span style={{ fontSize: "16px" }}>{text}</span>,
    }));
  }, []);

  const handleKeyDown = (event, type) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleFilter(type);
    }
  };

  const handleFilter = (type) => {
    trackFeatureAction("Reports", "Employees Registration", "search");
    const columnName = state?.selectedColumns?.[type]?.toLowerCase();
    const trimmedInput = state?.searchInputs?.[type]?.trim();

    dispatch(
      fetchFilteredRegistrationDetails({
        jwtBearer,
        filters: { [columnName]: trimmedInput },
      })
    );

    setState((prevState) => ({
      ...prevState,
      hasSearched: {
        ...prevState?.hasSearched,
        [type]: true,
      },
      pages: {
        ...prevState?.pages,
        [type]: { ...prevState?.pages?.[type], page: 1 },
      },
    }));
  };

  const handleReset = (type) => {
    trackFeatureAction("Reports", "Employees Registration", "reset");
    setState((prevState) => ({
      ...prevState,
      searchInputs: {
        ...prevState?.searchInputs,
        [type]: "",
      },
      selectedColumns: {
        ...prevState?.selectedColumns,
        [type]: "",
      },
      hasSearched: {
        ...prevState?.hasSearched,
        [type]: false,
      },
      filters: {
        ...prevState?.filters,
        [type]: {},
      },
    }));

    dispatch(
      fetchRegistrationDetails({
        jwtBearer,
        page: state?.pages?.registrationDetails?.page,
        filters: {},
        pageSize: state?.pages?.registrationDetails?.pageSize,
      })
    );

    setTriggerFilter(type);
  };

  useEffect(() => {
    if (triggerFilter) {
      handleFilter(triggerFilter);
      setTriggerFilter(null);
    }
  }, [triggerFilter]);

  const paginationConfig = (type) => {
    const total = state?.hasSearched?.registrationDetails
      ? filteredRegistrationDetailsData?.length
      : totalRegistrationDetailsCount;

    return {
      current: state?.pages?.registrationDetails?.page,
      pageSize: state?.pages?.registrationDetails?.pageSize,
      total: total,
      showTotal: (total, [start, end]) => `${start}-${end} of ${total} items`,
      onChange: (page, pageSize) =>
        setState((prevState) => ({
          ...prevState,
          pages: { ...prevState?.pages, [type]: { page, pageSize } },
        })),
    };
  };

  const renderSearchBar = (columns, type) => (
    <Space style={{ marginBottom: 16, marginLeft: 2 }}>
      <Select
        placeholder="Select Column"
        style={{ width: 200, height: 32, lineHeight: "32px" }}
        value={state?.selectedColumns?.[type] || undefined}
        onChange={(value) =>
          setState((prevState) => ({
            ...prevState,
            selectedColumns: {
              ...prevState?.selectedColumns,
              [type]: value,
            },
          }))
        }
      >
        {columns?.map((col) => (
          <Option key={col?.key} value={col?.dataIndex}>
            {col?.title?.props?.children}
          </Option>
        ))}
      </Select>
      <Input
        placeholder="Value"
        value={state?.searchInputs?.[type]}
        onChange={(e) =>
          setState((prevState) => ({
            ...prevState,
            searchInputs: {
              ...prevState?.searchInputs,
              [type]: e.target.value,
            },
          }))
        }
        onKeyDown={(e) => handleKeyDown(e, type)}
        style={{ width: 150, height: 32, lineHeight: "32px" }}
        disabled={!state?.selectedColumns?.[type]}
      />
      <Button
        type="primary"
        onClick={() => handleFilter(type)}
        style={{ height: 32, lineHeight: "32px" }}
      >
        Search
      </Button>
      {state?.hasSearched?.registrationDetails && (
        <Button
          onClick={() => handleReset(type)}
          style={{ width: 70, height: 32, lineHeight: "32px" }}
        >
          Reset
        </Button>
      )}
    </Space>
  );

//   const renderButtonByType = () => (
//     <StyledButton
//       type="primary"
//       onClick={() => handleAPIDownload()}
//       loading={buttonLoading}
//     >
//       Download Report
//     </StyledButton>
//   );

const renderButtonByType = () => (
    <StyledButton
      type="primary"
      onClick={() => handleAPIDownload()}
      loading={buttonLoading}
    >
      Download Report
    </StyledButton>
  );

//   const handleAPIDownload = () => {
//     setButtonLoading(true);

//     dispatch(downloadRegistrationReport({ jwtBearer,  }))
//       .then(() => {
//         setButtonLoading(false);
//       })
//       .catch(() => {
//         setButtonLoading(false);
//       });
//   };

// const handleAPIDownload = () => {
//     if (!startDate || !endDate) {
//       alert('Please select both start and end dates.');
//       return;
//     }
  
//     setButtonLoading(true);
  
  
//     dispatch(downloadRegistrationReport({ jwtBearer, startDate, endDate }))
//       .then(() => {
//         setButtonLoading(false);
//       })
//       .catch((error) => {
//         setButtonLoading(false); 
//         console.error('Error downloading registration report:', error);
//       });
//   };

const handleAPIDownload = () => {
  trackFeatureAction("Reports", "Employees Registration", "download");
  setButtonLoading(true);

  dispatch(downloadRegistrationReport({ jwtBearer }))
    .then(() => {
      setButtonLoading(false);
    })
    .catch((error) => {
      setButtonLoading(false);
      console.error('Error downloading registration report:', error);
    });
};

  
  const handleStartDateChange = (date) => {
    setStartDate(date);
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
  };

  return (
    <>
      <Card
        title={<span style={{ fontWeight: 600, fontSize: "24px", fontFamily: "poppins-font, sans-serif" }}>REGISTRATION REPORT</span>}
        bordered
        extra={
            <div style={{ display: 'flex', flexDirection: 'row', gap: '20px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        {renderButtonByType()}
      </div>
    </div>
        }
      >
        {renderSearchBar(defineColumns(registrationDetailsData || []), "registrationDetails")}

        {isLoadingFilteredRegistrationDetails || isLoadingRegistrationDetails ? (
          <div className="spinner-container">
            <HashLoader color="#f57171" />
          </div>
        ) : errorRegistrationDetails ? (
          <Alert message={errorRegistrationDetails} type="error" />
        ) : (
          <StyledTable
            columns={defineColumns(registrationDetailsData)}
            dataSource={
              state?.hasSearched?.registrationDetails
                ? filteredRegistrationDetailsData
                : registrationDetailsData
            }
            pagination={paginationConfig("registrationDetails")}
            locale={{ emptyText: <Empty description="No data available" /> }}
          />
        )}
      </Card>
    </>
  );
};

export default RegistrationDetails;
